import { render } from "./DotsVertical.vue?vue&type=template&id=5c5a9e57"
const script = {}
script.render = render

export default script